module.exports = __webpack_public_path__ + "static/media/pau_logo1.9b9ef721.png";